<template>
	<v-container class="mt-4 ml-2">
	  <v-row>
	  	<v-col cols="12" md="10">
			  <v-data-table
			    :headers="headers"
			    :items="preguntas"
			    class="elevation-6"
			    dense
			    :search="search"
			  >
			    <template v-slot:top>
			      <v-toolbar
			        flat
			      >
			      	<!-- Titulo -->
			        <v-toolbar-title>Preguntas</v-toolbar-title>
			        <v-divider
			          class="mx-4"
			          inset
			          vertical
			        ></v-divider>
			        <v-spacer></v-spacer>
			        <!-- Dialogo para agregar una nueva pregunta -->
			        <v-dialog
			          v-model="dialog"
			          max-width="500px"
			        >
			          <template v-slot:activator="{ on, attrs }">
			            <v-btn
			              color="primary"
			              dark
			              class="mb-2"
			              v-bind="attrs"
			              v-on="on"
			              small
			              rounded
			            >
			              Agregar pregunta
			            </v-btn>
			          </template>
			          <v-card>
			            <v-card-title>
			              <span class="text-h5">{{ formTitle }}</span>
			            </v-card-title>

			            <v-card-text class="pb-0">
			              <v-container>
			                <v-row>
			                  <v-col cols="12">
			                    <v-text-field
			                      v-model="editedItem.pregunta"
			                      label="Pregunta"
			                      outlined
			                      dense
			                      hide-details
			                    ></v-text-field>
			                  </v-col>

			                  <v-col cols="12" sm="6" >
			                    <v-text-field
			                      v-model="editedItem.valor"
			                      label="Valor"
			                      type="number"
			                      outlined
			                      dense
			                      hide-details
			                    ></v-text-field>
			                  </v-col>
			                </v-row>
			              </v-container>
			            </v-card-text>

			            <!-- Acciones, guardar y cancelar -->
			            <v-card-actions>
			              <v-spacer></v-spacer>
			              <v-btn
			                color="blue darken-1"
			                text
			                @click="close"
			              >
			                Cancelar
			              </v-btn>
			              <v-btn
			                color="blue darken-1"
			                @click="save"
			                dark
			              >
			                Guardar
			              </v-btn>
			            </v-card-actions>
			          </v-card>
			        </v-dialog>

			        <!-- Eliminar el item  -->
			        <v-dialog v-model="dialogDelete" max-width="500px">
			          <v-card>
					      	<v-card-text>
						      	<v-row>
						      		<v-col cols="6">
						      			<v-card class="elevation-0" height="100%" style="display: table;">
							      			<div class="text-h6" style="display: table-cell; vertical-align: middle;">
							      				<strong>Eliminar</strong> ¿Estás seguro que deseas eliminar la pregunta?
								      			<v-card-actions class="pt-6">
								      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
								      			  <v-btn color="error" text large class="mr-2" @click="closeDelete()">No, cancelar</v-btn>
								      			  <!-- Guardar la información  -->
								      			  <v-btn color="#5C5C5C" dark class="elevation-6" large @click="deleteItemConfirm()">Si</v-btn>
								      			</v-card-actions>
							      			</div>
						      			</v-card>
						      		</v-col>
						      		<v-col cols="6">
						      			<v-img src="@/assets/borrar.png"></v-img>
						      		</v-col>
							      </v-row>
					      	</v-card-text>
					      </v-card>

			        </v-dialog>
			      </v-toolbar>
			      <v-card class="elevation-0">
			        <v-card-text>
			        	<div class="text-body-1"><strong>Total de puntos: {{ sumaPuntos }}</strong></div>  
			        </v-card-text>
			      </v-card>
			    </template>

			    <!-- Boton de actualizar -->
			    <template v-slot:no-data>
			      <v-btn
			        color="primary"
			        @click="initialize"
			      	rounded
			      	small
			      >
			        Actualizar
			      </v-btn>
			    </template>
			    <template v-slot:item.actions="{ item }">
			      <v-icon
			        small
			        class="mr-2"
			        color="primary"
			        @click="editItem(item)"
			      >
			        mdi-pencil
			      </v-icon>
			      <v-icon
			        small
			        color="error"
			        @click="deleteItem(item)"
			      >
			        mdi-delete
			      </v-icon>
			    </template>
			    <template v-slot:no-data>
			      <v-btn
			        color="primary"
			        @click="initialize"
			      	rounded
			      	small
			      >
			        Actualizar
			      </v-btn>
			    </template>
			  </v-data-table>
	  	</v-col>
	  </v-row>

	  <!-- Dialog de carga -->
    <v-overlay :value="overlay">
      <v-card
      	width="300"
        color="primary"
        dark
      >
        <v-card-text  class="text-subtitle-1">
          Cargando...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0 mt-2"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-overlay>

	  <!-- Dialogo para indicar que todo esta correcto -->
    <v-dialog
      v-model="dialogSuccess"
      hide-overlay
      max-width="400"
    >
      <v-card>
      	<v-card-text>
	      	<v-row>
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-h6" style="display: table-cell; vertical-align: middle;">
		      				<strong>¡Bien!</strong> Datos grabados correctamente
			      			<v-card-actions class="pt-6">
			      				<v-spacer></v-spacer>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="green" dark class="elevation-6" large @click="dialogSuccess = false">Ok</v-btn>
			      				<v-spacer></v-spacer>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="6">
	      			<v-img src="@/assets/correcto.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>
	  
    <!-- Dialogo para indicar errores -->
    <v-dialog
      v-model="dialogError"
      persistent
      max-width="600"
    >
      <v-card>
      	<v-card-text>
	      	<v-row>
	      		<v-col cols="6">
	      			<v-card class="elevation-0" height="100%" style="display: table;">
		      			<div class="text-h6" style="display: table-cell; vertical-align: middle;">
		      				<span v-if="errorBack">
		      					<strong>ERROR</strong> Da clic en "COPIAR" para guardar el error y enviarlo a sistemas
		      				</span>
		      				<span v-else>
		      					<strong>ERROR</strong> {{error}}
		      				</span>
			      			<v-card-actions class="pt-6">
			      				<!-- Cerrar dialogo de confirmación y abrir el dialogo de editar la clase -->
			      			  <v-btn color="error" text large class="mr-2" @click="dialogError = false">Cerrar</v-btn>
			      			  <!-- Guardar la información  -->
			      			  <v-btn color="#D60F24" dark class="elevation-6" large @click="copiarPortapapeles()" v-if="errorBack">{{textoCopiado}}</v-btn>
			      			  <v-btn color="#D60F24" dark class="elevation-6" large @click="dialogError = false" v-else>Ok</v-btn>
			      			</v-card-actions>
		      			</div>
	      			</v-card>
	      		</v-col>
	      		<v-col cols="6">
	      			<v-img src="@/assets/eliminar.png"></v-img>
	      		</v-col>
		      </v-row>
      	</v-card-text>
      </v-card>
    </v-dialog>

	</v-container>
</template>
<script>
import axios from 'axios';
	var moment = require('moment');
  moment.locale(); 
  export default {
    data: () => ({
    	search:'',
      dialog: false,
      dialogDelete: false,
      headers: [
        { text: 'ID'        , value: 'idcalidad_preguntas' },
        { text: 'Pregunta'  , value: 'pregunta'            },
        { text: 'Valor'     , value: 'valor'               },
        { text: 'Fecha'     , value: 'fecha_creacion'      },
        { text: 'Actions'   , value: 'actions'    , sortable: false },
      ],
      editedIndex: -1,
      editedItem: {
      	idcalidad_preguntas:0,
        pregunta: '',
        valor: 0,
      },
      defaultItem: {
      	idcalidad_preguntas:0,
        pregunta: '',
        valor: 0,
      },
      escuela:null,
      fecha:null,

      dialogError: 	false,
			dialogSuccess:false,
			error: 				'',
			successMensaje:'',
			overlay: 			false,

			textoCopiado:'COPIAR',
			sumaPuntos: 0,
			errorBack:false,
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar pregunta' : 'Editar Pregunta'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
      	this.sumaPuntos = 0
      	this.textoCopiado = 'COPIAR'
      	this.overlay = true
        this.preguntas = []
        this.$http.get('calidad.preguntas.all').then(response=>{
        	this.preguntas = response.data
        	// Contar la cantidad de puntos
        	for(const i in this.preguntas){
        		this.sumaPuntos += this.preguntas[i].valor
        	}
        	this.overlay = false
        }).catch(error=>{
        	if(error.body.message){
        		this.error = error.body.message
        	}else{
        		this.error = error.body
        	}
        	this.errorBack = true
        	this.overlay = false
        	this.dialogError = true
        })
      },

      editItem (item) {
      	// Buscamos la pregunta
        this.editedIndex = this.preguntas.indexOf(item)
        // Buscamos y asignamos lo que se encontro a un bojeto
        this.editedItem = Object.assign({}, item)
        // Abrimos el dialogo de editar
        this.dialog = true
      },

      // Funcion para abrir el dialogo de borrado
      deleteItem (item) {
      	// Buscamos la pregunta 
        this.editedIndex = this.preguntas.indexOf(item)
        // Buscamos y asignamos lo que se encontro a un bojeto
        this.editedItem = Object.assign({}, item)
        // Abrimos el dialogo de eliminar
        this.dialogDelete = true
      },

      deleteItemConfirm () {
      	// Abirmos la carga
      	this.overlay = true

      	// Mandar el deleted
      	this.editedItem.deleted = 1

      	// Actualizar
        this.$http.put('calidad.preguntas.update', this.editedItem).then(response=>{
        	// Cerrar el cuadro de dialogo
        	this.dialogDelete = false
        	// Cerrar la carga
        	this.overlay = false
        	// Abrir modal de todo correcto
      		this.dialogSuccess = true
      		// Actualizar ventana
        	this.initialize()
        }).catch(error=>{
        	this.dialogDelete = false
        	if(error.body.message){
        		this.error = error.body.message
        	}else{
        		this.error = error.body
        	}
        	this.errorBack = true
        	this.overlay = false
        	this.dialogError = true
        })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
      	this.sumaPuntos = 0
      	for(const i in this.preguntas){
      		this.sumaPuntos += this.preguntas[i].valor
      	}

      	if((this.sumaPuntos + parseInt(this.editedItem.valor)) > 100 ){
        	this.errorBack = false
					this.error = 'Los puntos no pueden pasar de 100 - ' + (this.sumaPuntos + this.editedItem.valor)
        	this.overlay = false
        	this.dialogError = true
      		return
      	} 
      	this.overlay = true

        if (this.editedIndex > -1) {
          this.$http.put('calidad.preguntas.update', this.editedItem).then(response=>{
	        	this.overlay = false
        		this.dialogSuccess = true
	        	this.initialize()
	        }).catch(error=>{
	        	if(error.body.message){
	        		this.error = error.body.message
	        	}else{
	        		this.error = error.body
	        	}
	        	this.errorBack = true
	        	this.overlay = false
	        	this.dialogError = true
	        })

	      // Agregar
        } else {
        	this.$http.post('calidad.preguntas.add',this.editedItem).then(response=>{
        		this.overlay = false
        		this.dialogSuccess = true
	        	this.initialize()
	        }).catch(error=>{
	        	if(error.body.message){
	        		this.error = error.body.message
	        	}else{
	        		this.error = error.body
	        	}
	        	this.errorBack = true
	        	this.overlay = false
	        	this.dialogError = true
	        })
        }
        this.close()
      },

      openDialogError (mensaje) {
      	this.error       = mensaje
      	this.dialogError = true
      },

      openDialogSuccess ( mensaje ){
      	this.successMensaje = mensaje
      	this.dialogSuccess  = true
      },

      copiarPortapapeles () {
        navigator.clipboard.writeText(this.error).then(() => {
          this.textoCopiado = 'COPIADO'
        }).catch(err => {
          console.log('Something went wrong', err);
        })
      }
    },
  }
</script>

